<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      cloudToken:JSON.parse(localStorage.getItem("cloudUser"))?JSON.parse(localStorage.getItem("cloudUser")).cloudToken:"",
    };
  },
  mounted() {
    
  },
};
</script>

<style>
/* div { 导致页面不能复制写到按钮内部去了
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
} */
body,
html {
  margin: 0;
  padding: 0;
  background-color: rgba(245, 245, 245, 1);
}
input,
textarea,
select {
  outline: none;
  resize: none;
  border: none;
}
#app {
  margin: auto;
  position: relative;
  /* 针对过期登录页面加的100% 如果对其他页面有影响在取消或者在看 */
  width: 100%;
  height: 100%;
  background-color: #F5F5F5;
  /* 以上 */
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #8F8F8F;
  font-size: 14px;
}

input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #8F8F8F;
  font-size: 14px;
}

input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #8F8F8F;
  font-size: 14px;
}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #8F8F8F;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue